import smoothscroll from "smoothscroll-polyfill";

const Common = {
  /**
   * タッチデバイスでの:hoverの挙動を無効化
   *
   */
  disableHoverOnTouchDevice() {
    const touchEnabled =
      "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    if (touchEnabled) {
      try {
        for (const si in document.styleSheets) {
          const styleSheet = document.styleSheets[si];
          if (!styleSheet.cssRules) continue;

          for (let ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
            if (!styleSheet.cssRules[ri].selectorText) continue;

            if (styleSheet.cssRules[ri].selectorText.match(":hover")) {
              styleSheet.deleteRule(ri);
            }
          }
        }
      } catch (ex) { }
    }
  },
  /**
   * 画面の幅が一定数以下の時にヘッダーのメニューのみを追従する
   *
   */
  followHeaderMenu() {
    window.onscroll = () => {
      const scroll = document.scrollingElement.scrollTop;
      if (scroll > 45) {
        document.querySelector("#globalHeader .menu_box").classList.add("fixed");
      } else {
        document.querySelector("#globalHeader .menu_box").classList.remove("fixed");
      }
    };
  },
  /**
   * ヘッダーのカテゴリ選択幅を可変に
   *
   */
  changeCategoryWidth() {
    const target = document.getElementById("headerSelectCategory");
    if (target == null) return;
    const catLength = target.selectedOptions[0].textContent.length;
    const catWidth = catLength + 4 + "em";
    target.style.width = catWidth;
  },
  /**
   * スマホのみ：スクロールでヘッダー検索窓の表示・非表示
   *
   */
  controllSearchBar() {
    let startPos = 0;
    const headerSp = document.querySelector('.js_header_sp');
    const hxStickies = document.querySelectorAll('.hx_sticky');

    window.addEventListener("scroll", () => {
      const scroll = document.scrollingElement.scrollTop;
      if (scroll < startPos || scroll < 100) {
        //上にスクロールしたとき検索窓を表示する
        //iPhoneで上スクロール時ページ最上部に来るとバウンスすることで下スクロール判定となるバグを回避のために「winScrollTop < 100」の条件追加
        headerSp.classList.remove('is_hide');
        hxStickies.forEach((hx_sticky)=>{
          hx_sticky.classList.remove('is_scroll');
        })
      } else {
        //下にスクロールしたとき検索窓を非表示にする
        headerSp.classList.add('is_hide');
        hxStickies.forEach((hx_sticky)=>{
          hx_sticky.classList.add('is_scroll');
        })
      }
      startPos = document.scrollingElement.scrollTop;
    });
  },
  /**
   * ヘッダーから検索した時にsubmitする(PC版のみサブカテゴリのパラメータを消去)
   *
   */
  searchServicesFromHeader() {
    const form = document.getElementById("serviceSearchForm");
    const windowWidth = window.innerWidth;
    if (windowWidth > 768) {
      // PC版であれば、hiddenSubCategoryのvalueを消してsubmit
      const hiddenSubCategory = document.getElementById("hiddenSubCategory");
      hiddenSubCategory.remove();
    }
    form.submit();
  },
  /**
   * 引数に入れたidを持つ要素にスクロールする
   *
   * @param {*} id
   */
  scrollToElement(id) {
    smoothscroll.polyfill();
    const elementId = id.startsWith("#") ? id.slice(1) : id;
    const scrollElement = document.getElementById(elementId);
    scrollElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  },
  /**
   * iOSで2回タップしないとリンクが動作しない不具合の対策
   *
   */
  onTouchStart() {
    document.querySelectorAll("a,button").forEach((element) => {
      element.addEventListener("touchstart", () => { });
    });
  },

  /**
   * 会員区分選択時の挙動
   *
   */
  toggleUserStatus() {
    const checkboxes = document.querySelectorAll(".check_userstatus input[type=checkbox]");

    function handleCheckboxChange(event) {
      const checkbox = event.target;
      const label = checkbox.parentElement;

      if (checkbox.checked) {
        label.classList.remove("is_uncheck");
      } else {
        label.classList.add("is_uncheck");
      }
    }

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", handleCheckboxChange);
    });
  },
};

document.addEventListener("DOMContentLoaded", () => {
  // ページロード後にグローバル定数にCommonを追加する
  Object.defineProperty(globalThis, "Common", {
    value: Common,
    writable: false,
  });
  Common.followHeaderMenu();
  Common.disableHoverOnTouchDevice();
  Common.controllSearchBar();
  Common.changeCategoryWidth();
  Common.onTouchStart();
  Common.toggleUserStatus();
});
